/**
 * @author NikolaV
 */

import * as React from 'react';
import { VehiclesFilter } from '@shared/vehicles/ui/VehiclesFilter';
import { VehicleList } from '@shared/vehicles/VehicleList';
import { observer } from 'mobx-react';
import { TabPane, Tabs } from '@shared/ui-react/Tabs';
import { MapPanelFilter } from '@shared/map/MapPanelFilter';
import { VehiclesStore } from '@shared/vehicles/VehiclesStore';
import { FilterSelectionFeedback } from '@shared/map/FilterSelectionFeedback';
import { VehiclesSortButton } from '@shared/vehicles/ui/VehiclesSortButton';
import { MapAssignmentsPanel } from '@shared/vehicles/assignments/MapAssignmentsPanel';
import { Button } from '@shared/ui-react/Button';


@observer
export class VehiclesPanelGeneric extends React.Component<{
    store: VehiclesStore,
    treeData: ITreeData,
    filterTab?: boolean,
    sidebarWidth?: number,
    onPanToVehicle: (vehicle: IVehicle) => void,
    onLoadModels: (uuids: string[]) => void,
    onFitVisible: () => void,
    readOnly: boolean
}> {
    render() {
        const store = this.props.store;
        return (
            <>
                <Tabs displayValue='flex' flexDirection='column' lazyLoad>
                    <TabPane title={__('js_vehicles.tab.overview')}>
                        <div className="flex-row gap-half" style={{ padding: '10px 0' }}>
                            <input type="text" placeholder={__('general.search')} value={store.filterText} style={{ flexGrow: 1, height: 'auto' }} maxLength={30}
                                   onChange={e => store.filterText = e.currentTarget.value}/>

                            <VehiclesSortButton store={this.props.store}/>

                            {!this.props.filterTab &&
                                <MapPanelFilter
                                    pinned={store.filterPinned}
                                    pinLeftOffset={this.props.sidebarWidth}
                                    opened={store.filterOpened}
                                    activeFiltersCount={store.numberOfAppliedFilters}
                                    clearFilter={store.clearFilter}
                                    detectVisibilityChange={false}
                                    togglePinned={() => {
                                        store.filterPinned = !store.filterPinned;
                                        store.filterOpened = true;
                                    }}
                                    toggleOpened={() => store.filterOpened = !store.filterOpened}>
                                    <VehiclesFilter store={store}/>
                                </MapPanelFilter>
                            }
                        </div>

                        <VehicleList vehiclesStore={store}
                                     onClick={v => this.props.onPanToVehicle(v)}
                                     theme="desktop"/>
                    </TabPane>

                    {this.props.filterTab &&
                        <TabPane title={__('general.filters')} badgeColor={store.numberOfAppliedFilters > 0 ? 'green' : null}>
                            <div style={{ marginTop: 10 }}>
                                <FilterSelectionFeedback filtersCount={store.numberOfAppliedFilters} onClearFilters={store.clearFilter} showDefaultText={false}/>
                                <VehiclesFilter store={store}/>
                                {this.props.onFitVisible && <div className='flex-row'><Button icon='iki iki-fit-to-screen' onClick={this.props.onFitVisible} style={{ margin: '0px auto 20px'}} /></div>}
                            </div>
                        </TabPane>
                    }

                    <TabPane title={__('js_vehicles.tab.assignments')}>
                        <div className="flex-column of-a padded-half gap-half">
                            {!this.props.store.isInitialLoad &&
                                <MapAssignmentsPanel
                                    vehicles={this.props.store.vehicles}
                                    treeData={this.props.treeData}
                                    onLoadModels={this.props.onLoadModels}
                                    onClickVehicle={v => this.props.onPanToVehicle(v)}
                                    readOnly={this.props.readOnly}
                                />
                            }
                        </div>
                    </TabPane>
                </Tabs>
            </>
        );
    }
}
